import * as z from "zod";
import type { TFunction } from "i18next";

export const createDocumentSchema = (t: TFunction) =>
  z.object({
    file: z
      .instanceof(File, {
        message: t("management.releaseNotes.validation.fileRequired"),
      })
      .refine(
        (file) => file.type === "application/pdf",
        t("management.releaseNotes.validation.fileInvalidType"),
      ),
    version: z
      .string()
      .min(1, t("management.releaseNotes.validation.versionRequired")),
  });

export type DocumentUploadFormData = z.infer<
  ReturnType<typeof createDocumentSchema>
>;
